{
  "aboutFarmJoinCodes": "About Farm Join Codes",
  "back": "Back",
  "codeExpired": "Code Expired",
  "codeExpiredErrorMessage": "You farm join code has expired. In order to allow new users to join your farm account, you must create a new code.",
  "codeExpiresWithColon": "Code Expires: ",
  "codeNotCreated": "Code Not Created",
  "codeNotCreatedErrorMessage": "You need to create a new farm join code to allow users to join your farm.",
  "codeWithColon": "Code: ",
  "copyCode": "Copy",
  "farmJoinCode": "Farm Join Code",
  "farmJoinCodeHelpSummary": "Farm Join Codes are 6-digit randomly-generated codes which allow new users to join a farm account. When the user joins, they will start with permissions specified the farm.\n\nFarm join codes expire after a certain period of time. If you create a code and the code expires, you will need to create a new code if you want new users to be able to join your farm.",
  "farmJoinCodeNotCreatedMessage": "You need to create a new farm join code to allow users to join your farm.",
  "farmJoinCodeShareMessageWithActiveFarmNameAndCodeString": "Use this farm join code to join farm {{activeFarmName}}\n{{codeString}}",
  "farmJoinCodeShareTitleWithActiveFarmName": "[FarmHQ]: Join Code for {{activeFarmName}}",
  "farmJoinCodeStatus": {
    "ACTIVE": "Active",
    "EXPIRED": "Expired",
    "NOT_CREATED": "Not Created"
  },
  "farmJoinCodeTitle": "Farm Join Code",
  "newCode": "New Code",
  "newFarmJoinCode": "New Farm Join Code",
  "newFarmJoinCodeHelpSummary": "When a user joins your farm by entering a Farm Join Code, they are assigned the permissions that were specified when that code was created. A user's permissions can be changed later by a farm administrator.",
  "note": "Note: ",
  "shareCode": "Share",
  "somethingWentWrong": "Something went wrong",
  "unableToCopyCode": "Unable to copy code",
  "yourCode": "Your Code"
}
